import { render } from "./ChangePasswordForm.vue?vue&type=template&id=4729dd62&ts=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=4729dd62&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__